/* unplugin-vue-components disabled */import script from "./FormDesigner.vue?vue&type=script&setup=true&lang=js"
export * from "./FormDesigner.vue?vue&type=script&setup=true&lang=js"

import "./FormDesigner.vue?vue&type=style&index=0&id=1d299742&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d299742"]])

export default __exports__